import { router } from '@/router'
import type { AppRouter } from '@/router/types'
import { store } from '@/store'
import type { AppStore } from '@/store/types'

export interface IAppContext {
  router: AppRouter
  store: AppStore
}

export function getAppContext(): IAppContext {
  return {
    router,
    store,
  }
}
